import { Box, MenuItem, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { INotification } from "./NotificationManagement";
import { Link } from "react-router-dom";

const IndivisualNotification = ({
	id,
	notif,
}: {
	notif: INotification;
	id: number;
}) => {
	const { mutate: updateRead, isPending } = useApiMutation<void, void>({
		method: "PATCH",
		endPoint: `/api/admin/notification/${id}`,
		invalidateQueries: ["notification"],
	});

	const navigationType =
		notif.notification_type === "b2b_invoice"
			? `/b2b/b2b-invoice/${notif?.related_id}`
			: notif.notification_type === "visitor_invoice"
			? `/visitor/visitor-invoice/${notif?.related_id}`
			: notif.notification_type === "exhibitor_invoice"
			? `/exhibitor/invoice-list/${notif?.related_id}`
			: notif.notification_type === "exhibitor_additional_service"
			? `/exhibitor/invoice-list/${notif?.related_id}`
			: notif.notification_type === "exhibitor_registration"
			? `/exhibitor/list/${notif.related_id}`
			: notif.notification_type === "exhibitor_stall_request"
			? `/exhibitor/list/${notif.related_id}?key=stall`
			: notif.notification_type === "visitor_registration"
			? `/visitor/details/${notif.related_id}`
			: notif.notification_type === "visitor_ticket" ||
			  notif.notification_type === "visitor_ticket_purchase"
			? `/visitor/details/${notif.related_id}`
			: notif.notification_type === "b2b_registration"
			? `/b2b/list/${notif.related_id}`
			: notif.notification_type === "exhibitor_money_receipt"
			? `/exhibitor/money-receipt/details/${notif.related_id}`
			: notif.notification_type === "b2b_money_receipt"
			? `/b2b/money-receipt/details/${notif.related_id}`
			: notif.notification_type === "visitor_money_receipt"
			? `/visitor/money-receipt/details/${notif.related_id}`
			: "";

	function calculateTimeDifference(givenTimeStr) {
		// Parse the given time and get the current time
		const givenTime: any = new Date(givenTimeStr);
		const currentTime: any = new Date();

		// Calculate the difference in milliseconds
		const differenceInMs = currentTime - givenTime;

		// Convert to absolute value for positive difference
		const absoluteDifferenceInMs = Math.abs(differenceInMs);

		// Convert to total minutes and hours
		const totalMinutes = Math.floor(absoluteDifferenceInMs / (1000 * 60));
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes % 60;

		// Determine if the time is in the past or future
		const isPast = differenceInMs >= 0;

		return {
			hours,
			minutes,
			isPast,
		};
	}
	const totalDuration = calculateTimeDifference(notif.created_at);
	const diffHours = dayjs().diff(dayjs(notif?.created_at), "hour");

	const displayTime =
		diffHours < 24
			? `${diffHours} hours ago`
			: `${Math.floor(diffHours / 24)} day${
					Math.floor(diffHours / 24) > 1 ? "s" : ""
			  } ago`;

	return (
		<Link to={navigationType}>
			<MenuItem
				key={id}
				sx={{
					"&:hover": { backgroundColor: "#f0f0f0" },
					alignItems: "flex-start",
				}}
				onClick={() => notif?.read_status === 0 && updateRead()}
			>
				<Box>
					<Typography
						variant='body2'
						fontWeight='bold'
						sx={{
							textWrap: "wrap",
							color: notif?.read_status ? "" : "black",
						}}
					>
						{notif?.message}
					</Typography>
					<Typography
						color='text.secondary'
						sx={{
							fontSize: "11px",
							color: notif?.read_status ? "" : "black",
						}}
					>
						{dayjs(notif?.created_at).format("ddd, MM YYYY")}
						{", "}
						{displayTime}
					</Typography>
				</Box>
			</MenuItem>
		</Link>
	);
};

export default IndivisualNotification;
